export default __webpack_public_path__ + "static/spectrum_mobile_full-70fab26daf6edead88bebb2defe9b619.jpg";